import { TillageImplement } from '@cibo/core'
import dayjs from 'dayjs'
import * as Yup from 'yup'
import { ValidationSchemaFunctionArguments } from '../types'
import { isDetailRequired } from '../useIsRequired'

export const TillageEventValidationSchema = ({
  t,
  requirement,
}: ValidationSchemaFunctionArguments) =>
  Yup.object()
    .shape({
      date: isDetailRequired({ requirement, fieldName: 'date' })
        ? Yup.date()
            .required(t('required', { context: 'date' }))
            .test(
              'dateRequired',
              t('required_fourDigitYear'),
              // @ts-ignore typing doesn't like this.
              (date: string) => dayjs(date).year() > 1969
            )
            .typeError(t('required', { context: 'date' }))
        : Yup.date().nullable(),
      implement: Yup.string<TillageImplement>()
        .required(t('required', { context: 'implement' }))
        .typeError(t('required', { context: 'implement' })),
      depth: Yup.number()
        .min(0, t('min', { context: 'depth' }))
        [isDetailRequired({ requirement, fieldName: 'depth' }) ? 'required' : 'optional'](
          t('required', { context: 'depth' })
        ),
      rowSpacing: Yup.number().when('implement', ([implement], schema) =>
        implement === 'stripTill'
          ? schema
              .min(0, t('min', { context: 'rowSpacing' }))
              .required(t('required', { context: 'rowSpacing' }))
              .typeError(t('required', { context: 'rowSpacing' }))
          : schema.optional()
      ),
      stripWidth: Yup.number().when('implement', ([implement], schema) =>
        implement === 'stripTill'
          ? schema
              .min(0, t('min', { context: 'stripWidth' }))
              .max(99, t('max', { context: 'stripWidth' }))
              .required(t('required', { context: 'stripWidth' }))
              .typeError(t('required', { context: 'stripWidth' }))
          : schema.optional()
      ),
      residueRemaining: isDetailRequired({ requirement, fieldName: 'residueRemaining' })
        ? Yup.number()
            .min(0, t('min', { context: 'residueRemaining' }))
            .max(1, t('max', { context: 'residueRemaining' }))
            .required(t('required', { context: 'residueRemaining' }))
            .typeError(t('required', { context: 'residueRemaining' }))
        : Yup.number().nullable(),
    })
    .required()
